import type { OptionsDocument } from 'paintscout'
import { getPipelines } from '../../options/get-pipelines/get-pipelines'

export function getStageLabel(args: { options: OptionsDocument; pipelineKey: string; stageKey: string }) {
  const { options, pipelineKey, stageKey } = args

  const pipelines = getPipelines({ options })
  const pipeline = pipelines.find((pipeline) => pipeline.key === pipelineKey)

  if (!pipeline) {
    // console.log(`Pipeline with key ${pipelineKey} not found`)
    return '' // TODO: Handle this case properly - temp while lots of data is incomplete
    throw new Error(`Pipeline with key ${pipelineKey} not found`)
  }
  const stage = pipeline.stages.find((stage) => stage.key === stageKey)
  if (!stage) {
    // console.log(`Stage with key ${stageKey} not found`)
    return '' // TODO: Handle this case properly - temp while lots of data is incomplete
    throw new Error(`Stage with key ${stageKey} not found`)
  }
  return stage.label
}
